<template>
  <Error v-if="shouldCreateWorkspace" error="should-create-workspace" />
  <div v-else id="calendar">
    <section>
      <WeekCalendar />
    </section>
  </div>
</template>

<script>
import WeekCalendar from '../../components/Calendar/WeekCalendar.vue';

export default {
  components: {
    WeekCalendar,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped src="./Calendar.scss"></style>
